import { useEffect, useState } from 'react'
import { ApiResponse } from '../../../components/cardsTrade/types'

import RevertIcon from '../../../assets/revertBlueIcon.svg'
export function Exchange() {
  const [data, setData] = useState<ApiResponse>({} as ApiResponse)
  const [valor, setValor] = useState('')
  const [currencySignal, setCurrency] = useState('')

  // const formatCurrency = (valor: any) => {
  // 	return new Intl.NumberFormat("pt-BR", {
  // 		style: "currency",
  // 		currency: "BRL",
  // 	}).format(valor);
  // };

  const formatCurrency = (valor: any) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 4,
      maximumFractionDigits: 4,
    }).format(valor)
  }

  // function formatGuarani(valor: any) {
  // 	const formatter = new Intl.NumberFormat("pt-BR", {
  // 		style: "decimal",
  // 		currency: "PYG",
  // 		minimumFractionDigits: 0,
  // 	}).format(valor);

  // 	return `R$ ${formatter}`;
  // }

  function formatGuarani(valor: any) {
    const formatter = new Intl.NumberFormat('pt-BR', {
      style: 'decimal',
      minimumFractionDigits: 4,
      maximumFractionDigits: 4,
    }).format(valor)

    return `R$ ${formatter}`
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `https://economia.awesomeapi.com.br/last/${moedas}`
        )
        if (!response.ok) {
          throw new Error('Network response was not ok')
        }
        const jsonData: ApiResponse = await response.json()

        setData(jsonData)
        const valorFormatado = formatCurrency(jsonData.USDBRL.bid)

        setValor(valorFormatado)
        setCurrency('$')
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }

    fetchData()
  }, [])

  const moedas =
    'USD-BRL,USDT-BRL,EUR-BRL,BTC-BRL,ARS-BRL,JPY-BRL,GBP-BRL,AUD-BRL,CAD-BRL,CHF-BRL,CNY-BRL,PYG-BRL,UYU-BRL'

  const handleSelectChange = (event: any) => {
    const novoValor = event.target.value
    if (novoValor == 'USD-BRL') {
      const valorFormatado = formatCurrency(data?.USDBRL?.bid)
      setValor(valorFormatado)
      setCurrency('$')
    }
    if (novoValor == 'EUR-BRL') {
      const valorFormatado = formatCurrency(data?.EURBRL?.bid)
      setValor(valorFormatado)
      setCurrency('€')
    }
    if (novoValor == 'ARS-BRL') {
      const valorFormatado = formatCurrency(data?.ARSBRL?.bid)
      setValor(valorFormatado)
      setCurrency('$')
    }
    if (novoValor == 'AUD-BRL') {
      const valorFormatado = formatCurrency(data?.AUDBRL?.bid)
      setValor(valorFormatado)
      setCurrency('$')
    }
    if (novoValor == 'CAD-BRL') {
      const valorFormatado = formatCurrency(data?.CADBRL?.bid)
      setValor(valorFormatado)
      setCurrency('$')
    }
    if (novoValor == 'CHF-BRL') {
      const valorFormatado = formatCurrency(data?.CHFBRL?.bid)
      setValor(valorFormatado)
      setCurrency('CHF')
    }
    if (novoValor == 'CNY-BRL') {
      const valorFormatado = formatCurrency(data?.CNYBRL?.bid)
      setValor(valorFormatado)
      setCurrency('¥')
    }
    if (novoValor == 'GBP-BRL') {
      const valorFormatado = formatCurrency(data?.GBPBRL?.bid)
      setValor(valorFormatado)
      setCurrency('£')
    }
    if (novoValor == 'JPY-BRL') {
      const valorFormatado = formatCurrency(data?.JPYBRL?.bid)
      setValor(valorFormatado)
      setCurrency('¥')
    }
    if (novoValor == 'PYG-BRL') {
      const valorFormatado = formatGuarani(data?.PYGBRL?.bid)
      setValor(valorFormatado)
      setCurrency('₲')
    }
    if (novoValor == 'UYU-BRL') {
      const valorFormatado = formatCurrency(data?.UYUBRL?.bid)
      setValor(valorFormatado)
      setCurrency('$U')
    }
  }

  return (
    <div className="flex flex-col exchange-card">
      <h6 className="title-text font-bold full-hd:mb-2 qhd:mb-4 qhd-plus:mb-4 4k:mb-5 5k:mb-5">
        Câmbio
      </h6>
      <div className="border-radius-container flex flex-col items-center justify-center h-full w-full bg-[#FBFAFA] border border-[#818181] shadow-md 4k:gap-6 5k:gap-12">
        <div className="flex flex-col items-start justify-start self-start mx-auto 4k:gap-6 5k:gap-12">
          <span className="text-[#191919]  exchange-text py-1 ">
            Selecione a moeda
          </span>
          <select
            name="Dolar Americano"
            id=""
            className="exchange-text px-2 border border-[#D9D9D9]"
            onChange={handleSelectChange}
          >
            <option defaultChecked value="USD-BRL">
              Dolar Americano
            </option>
            <option value="ARS-BRL">Peso Argentino</option>
            <option value="AUD-BRL">Dólar Australiano</option>
            <option value="CAD-BRL">Dólar Canadense</option>
            <option value="CHF-BRL">Franco Suiço</option>
            <option value="CNY-BRL">Yuan Chines</option>
            <option value="EUR-BRL">Euro</option>
            <option value="GBP-BRL">Libra Esterlina</option>
            <option value="JPY-BRL">Iene Japones</option>
            <option value="PYG-BRL">Guarani Paraguaio</option>
            <option value="UYU-BRL">Peso Uruguaio</option>
          </select>
          <span className="text-[#191919] exchange-text">Conversão</span>
        </div>
        <div className="conversion-text flex items-center gap-4 5k:gap-8 ">
          <span>{currencySignal} 1,00</span>
          <span>
            <img src={RevertIcon} className="exchange-icon" alt="" />
          </span>
          <span>{valor}</span>
        </div>
      </div>
    </div>
  )
}
